import React from 'react';
import { RouteProps } from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';
import LockedPage from '../components/LockedPage';
import { lnTheme, lnTokens } from '../Router';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    .ant-table-column-sorters {
      float: left;
    }
    
    .ant-switch:not(.ant-switch-checked):not(.ant-switch-disabled) {
      background: transparent;
      border: 1px solid ${lnTokens.satellite};

      &:hover {
        border: 1px solid ${lnTokens.asteroid};

        .ant-switch-handle::before {
          background-color: ${lnTokens.asteroid};
        }
      }

      .ant-switch-handle {
        height: 16px;
        width: 16px;

        &::before {
          background-color: ${lnTokens.satellite};
        }
      }

      &.ant-switch-small .ant-switch-handle {
        height: 10px;
        width: 10px;
      }
    }
  `;

const Unauthenticated: React.FC<RouteProps> = () => {
  return (
    <ConfigProvider theme={lnTheme}>
      <GlobalStyle />
      <Layout style={{ minHeight: '100vh' }}>
        <LockedPage status={'unauthorized'} email=''/>
      </Layout>
    </ConfigProvider>
  );
};

export default Unauthenticated;
